import React, { useState, SyntheticEvent, SetStateAction, Dispatch } from "react";
import useClickExternalLink from "../../../hooks/useClickExternalLink";
import { ACTION_DISPLAY_TYPES } from "../../../constants/enums";

import Action from "../../Common/Action";
import i18n from "../../../i18n/config";

const SetupFaceCheckBody = ({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) => {
  const openExternalLinksModal = useClickExternalLink();
  const [detailsState, setDetailsState] = useState({ open: false });

  const handleOpen = (e: SyntheticEvent<HTMLElement, Event>) => {
    const target = e.target as HTMLDetailsElement;
    const newState = { open: false };

    if (target.open) {
      newState.open = true;
    } else {
      newState.open = false;
    }

    setDetailsState({ ...newState });
  }
  return (
    <>
      <p className="marengo-grey">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.SUBHEADING")}</p>

      <div className="abyss-blue bg-color-iceberg-white padding-default-small border-radius">
        <p>{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.LIST_HEADING")}</p>
        <ol>
          <li>{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.LI_1")}</li>
          <li>{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.LI_2")}</li>
          <li>{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.LI_3")}</li>
        </ol>

        <p className="spacing-bottom-none">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.SUPPORT_DISCLAIMER")}</p>
      </div>

      <p className="marengo-grey spacing-bottom-none spacing-top-small">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.VIDEO_URL_HEADING")}</p>
      <a href="https://www.brightwell.com/crew-video/set-up-facecheck"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => openExternalLinksModal(e, "https://www.brightwell.com/crew-video/set-up-facecheck")}
        className="spacing-bottom-small"
      >
        https://www.brightwell.com/crew-video/set-up-facecheck
      </a>

      <details onToggle={(e) => handleOpen(e)} className="spacing-top-small border-all border--beluga-white padding-default-small border-radius">
        <summary>
          <div className="flex-row justify-content-between align-items-start">
            <p className="bold abyss-blue">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.DETAILS_SUMMARY")}</p>
            <span className="spacing-left-small font-size-xl abyss-blue">{detailsState.open ? '-' : '+'} </span>
          </div>
        </summary>

        <p className="marengo-grey spacing-bottom-none">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.DETAILS_DESCRIPTION")}</p>
      </details>

      <div className="flex-row justify-content-end v2 v3">
        <Action
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
          title={i18n.t("COMMON.CLOSE")}
          onClick={() => setOpen(false)}
          className="spacing-top-small"
        />
      </div>
    </>
  );
}

export default SetupFaceCheckBody;